import { render } from "./LotteryPage.vue?vue&type=template&id=c4617560"
import script from "./LotteryPage.vue?vue&type=script&lang=js"
export * from "./LotteryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__